import React, { useState, useRef, useEffect } from "react";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import LiveEventCustomMarkupGrid from '../Module/LiveEvent/LiveEventCustomMarkupGrid';
import { Translate } from "./LanguageChanger";
import Wrapper from "./shared/Wrapper";
import backIcon from "../assets/back-button.png";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { logFocusEvent } from "../Analytics/MatomoManager/loger";

let setFocus;
let resolution = window.RESOLUTION;

const LiveEventsHome = ({
  data,
  dsply = "none",
  FocusHandler,
  navigateToScreen,
  IsLiveEvent,
}) => {
  const [state, setState] = useState({
    liveEventData: [],
    shouldFocusToGrid: true,
    shouldFocusLiveEventsBTN: false,
    isBackButtonSelected: false,
  });

  const [rememberRowFocus, setRememberRowFocus] = useState(null);
  const [rememberColFocus, setRememberColFocus] = useState(null);

  const {
    liveEventData,
    shouldFocusToGrid,
    shouldFocusLiveEventsBTN,
    isBackButtonSelected,
  } = state;

  console.log("liveEventData", liveEventData);

  useEffect(() => {
    sendTestMatomoEvent({
      eventCategory:"Page",
      eventAction:"View",
      eventName:"Live Event",
      url: "live-event",
    });
  }, []);

  // FIX: Reset focus state when screen becomes visible
  useEffect(() => {
    if (dsply === true || dsply === "flex" || dsply === "block") {
      // Reset to initial focus state when returning to screen
      setState((prevState) => ({
        ...prevState,
        shouldFocusToGrid: true,
        shouldFocusLiveEventsBTN: false,
        isBackButtonSelected: false,
      }));
      
      if (data && data.length > 0) {
        loadData();
      }
    } else {
      // Clean up event listener when leaving screen
      window.removeEventListener("keydown", handleLiveEventKey);
    }
    
    return () => {
      window.removeEventListener("keydown", handleLiveEventKey);
    };
  }, [dsply]);

  const loadData = () => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    
    let filteredData = [];
    let shows = [];
    
    for (var i = 0; i < data.length; i++) {
      shows = [];
      if (data[i].list.length > 0) {
        const newObject = data[i].list.map((item) => ({
          ...item,
          playlist_type: data[i].playlist_type,
        }));
        shows.push(...newObject);
        let obj = {
          shows: shows,
          list: shows,
          above_recomendation: data[i].above_recomendation,
          ads_duration: data[i].ads_duration,
          banner: data[i].banner,
          below_recomendation: data[i].below_recomendation,
          cache_duration: data[i].cache_duration,
          category_id: data[i].category_id,
          component_action: data[i].component_action,
          genres_id: data[i].genres_id,
          id: data[i].id,
          is_repeated: data[i].is_repeated,
          layout: data[i].layout,
          playlist_type: data[i].playlist_type,
          genres_name: data[i].playlist_type,
          playlist_type_id: data[i].playlist_type_id,
          publisher_id: data[i].publisher_id,
          tag_id: data[i].tag_id,
          title: data[i].title,
          title_appearance: data[i].title_appearance,
          tv_ads_appearance: data[i].tv_ads_appearance,
        };
        filteredData.push(obj);
      }
    }
    
    setState((prevState) => ({
      ...prevState,
      loading: false,
      liveEventData: filteredData,
    }));
  };

  // FIX: Properly manage event listener based on display state
  useEffect(() => {
    if (dsply === true || dsply === "flex" || dsply === "block") {
      window.addEventListener("keydown", handleLiveEventKey);
    } else {
      window.removeEventListener("keydown", handleLiveEventKey);
    }
    
    return () => {
      window.removeEventListener("keydown", handleLiveEventKey);
    };
  }, [dsply, shouldFocusToGrid, isBackButtonSelected]);

  const handleLiveEventKey = (e) => {
      logFocusEvent("Live_Event_trigger", {
            pressedKey: e.keyCode,
        });
    switch (e.keyCode) {
      case 40:
        // Down arrow - move to grid
        if (isBackButtonSelected) {
          // Debug: Log the data structure
          console.log("=== DEBUG: LiveEventData ===", liveEventData);
          
          // Find the index of Live content row
          let liveRowIndex = -1;
          for (let i = 0; i < liveEventData.length; i++) {
            console.log(`Row ${i}:`, liveEventData[i].playlist_type, liveEventData[i].title, liveEventData[i].list?.length);
            if (liveEventData[i].playlist_type?.toLowerCase() === 'live' && 
                liveEventData[i].list && 
                liveEventData[i].list.length > 0) {
              liveRowIndex = i;
              break;
            }
          }
          
          console.log("Live content found at row:", liveRowIndex);
          
          // Set focus position FIRST before enabling grid focus
          const targetRow = liveRowIndex >= 0 ? liveRowIndex : 0;
          setRememberRowFocus(targetRow);
          setRememberColFocus(0);
          console.log("Setting focus to row:", targetRow);
          
          // Then enable grid focus in next tick to ensure focus position is set
          requestAnimationFrame(() => {
            setState((prevState) => ({
              ...prevState,
              shouldFocusToGrid: true,
              shouldFocusLiveEventsBTN: false,
              isBackButtonSelected: false,
            }));
          });
        }
        break;
      
      case 8:
      case 10009:
      case 461:
        console.log("back key....");
        setState((prevState) => ({
          ...prevState,
          shouldFocusToGrid: false,
          shouldFocusLiveEventsBTN: false,
        }));
        FocusHandler("LiveEventBackKey");
        window.removeEventListener("keydown", handleLiveEventKey);
        break;
      default:
        break;
    }
  };

  // Removed setFocus function as it's now handled in useEffect

  const handleBackButton = () => {
    FocusHandler("LiveEventBackKey");
  };

  const BackButtonClick = () => {
    setState((prevState) => ({
      ...prevState,
      shouldFocusToGrid: false,
      shouldFocusLiveEventsBTN: false,
    }));
    FocusHandler("LiveEventBackKey");
    window.removeEventListener("keydown", handleLiveEventKey);
  };

  const handleMarkupGridUPButton = () => {
    // Clear the remembered focus when moving to back button
    // This ensures fresh focus calculation on next down press
    setRememberRowFocus(null);
    setRememberColFocus(null);
    
    setState((prevState) => ({
      ...prevState,
      isBackButtonSelected: true,
      shouldFocusToGrid: false,
    }));
    console.log("handleMarkupGridUPButton - Focus cleared");
  };
  
  const handleMarkupGridDownButton = () => {
    // Debug: Log the data structure
    console.log("=== DEBUG: handleMarkupGridDownButton ===", liveEventData);
    
    // Find the index of Live content row
    let liveRowIndex = -1;
    for (let i = 0; i < liveEventData.length; i++) {
      console.log(`Row ${i}:`, liveEventData[i].playlist_type, liveEventData[i].title, liveEventData[i].list?.length);
      if (liveEventData[i].playlist_type?.toLowerCase() === 'live' && 
          liveEventData[i].list && 
          liveEventData[i].list.length > 0) {
        liveRowIndex = i;
        break;
      }
    }
    
    console.log("Live content found at row:", liveRowIndex);
    
    // Set focus position FIRST before enabling grid focus
    const targetRow = liveRowIndex >= 0 ? liveRowIndex : 0;
    setRememberRowFocus(targetRow);
    setRememberColFocus(0);
    console.log("Setting focus to row:", targetRow);
    
    // Then enable grid focus in next tick to ensure focus position is set
    requestAnimationFrame(() => {
      setState((prevState) => ({
        ...prevState,
        isBackButtonSelected: false,
        shouldFocusToGrid: true,
      }));
    });
    
    console.log("handleMarkupGridDownButton...");
  };
  
  const handLeMarkupGridLeftButton = () => {
    console.log("handLeMarkupGridLeftButton...");
  };

  const handleMarkupGridOKButton = (selectedItemInfo) => {
    window.removeEventListener("keydown", handleLiveEventKey);
    console.log(selectedItemInfo,"selectedItemInfo11")
    if(isBackButtonSelected){
      handleBackButton();
    }else{
      navigateToScreen("LiveEventDetailsScreen", selectedItemInfo);
    }
  };

  const styles = {
    applanguageContainer: {
      background: `url(${solidbackgroundimg})`,
      position: "absolute",
      display: dsply,
      flexDirection: "column",
      width: "100vw",
      height: "100vh",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      opacity: 1,
    },
  };

  return (
    <div style={styles.applanguageContainer}>
      <div
        style={{
          width: "93vw",
          height: "2px",
          background: '#0E1653',
          position: "absolute",
          marginLeft: "7rem",
          marginTop: "100px",
          opacity: "0.5",
        }}
      ></div>
      <div style={{ position: "absolute" }}>
        <Wrapper
          as="button"
          style={{
            backgroundColor: "transparent",
            border: "none",
            marginLeft: "3rem",
            borderRadius: "1rem",
            aspectRatio: "1/1",
            cursor: "pointer",
            position: "relative",
            top: "1rem",
            zIndex: "1",
            outline: isBackButtonSelected ? "4px solid #EC008C" : "none",
          }}
          onClick={(e) => {
            BackButtonClick();
          }}
        >
          <img src={backIcon} width={50} height={50} />
        </Wrapper>
      </div>
      <div style={{ position: "absolute" }}>
        <span
          style={{
            position: "absolute",
            top: resolution === "FHD" ? "47px" : "32px",
            left: resolution === "FHD" ? "821px" : "821px",
            width: resolution === "FHD" ? "201px" : "169px",
            height: resolution === "FHD" ? "45px" : "43px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            background: "none",
            borderStyle: "none",
            fontSize: resolution === "FHD" ? "40px" : "30px",
            color: "#fff",
            zIndex: 10,
          }}
        >
          <Translate langKey={'Live_Events'} />
        </span>
      </div>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "940px",
          overflow: "hidden",
          marginLeft: "7rem",
          marginTop: "205px",
        }}
      >
        <LiveEventCustomMarkupGrid
          handleMarkupGridDownButton={handleMarkupGridDownButton}
          screen={"liveEvent"}
          isBackButtonSelected={isBackButtonSelected}
          rowWidth={1802}
          rowHeight={358}
          gapBetweenRow={35}
          columnWidth={228}
          columnHeight={291}
          gapBetweenColumn={30}
          itemWidth={228}
          itemHeight={291}
          numRows={3}
          fontSize="32px"
          fontColor="#FFFFFF"
          selectionStyle="border"
          numColumns={7}
          shouldFocus={shouldFocusToGrid}
          data={liveEventData}
          IsLiveEvent={IsLiveEvent}
          marginLeft={0}
          marginTop={0}
          rowBgColor="#000000"
          rowBgImage=""
          columnBgImage=""
          columnBgColor={shouldFocusToGrid ? "#333333" : "transparent"}
          selectionColor={shouldFocusToGrid ? "#fff" : "transparent"}
          gapBetweenCatTitleAndItemList={15}
          verticalScrollStartIndex={0}
          horizontalScrollStartIndex={3}
          animationSpeed={100}
          handleBackButton={handleBackButton}
          handleMarkupGridUPButton={handleMarkupGridUPButton}
          handleMarkupGridOKButton={handleMarkupGridOKButton}
          handLeMarkupGridLeftButton={handLeMarkupGridLeftButton}
          rememberRowFocus={rememberRowFocus}
          setRememberRowFocus={setRememberRowFocus}
          rememberColFocus={rememberColFocus}
          setRememberColFocus={setRememberColFocus}
        />
      </div>
    </div>
  );
};

export default LiveEventsHome;